module.exports = __webpack_public_path__ + "static/media/CDA.e4672be4.xsl";